import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.contractTypes.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: "Autónomo", text: $t('data.contractTypes.Autónomo', 'Autónomo') },
    { value: "De duración determinada", text: $t('data.contractTypes.De duración determinada', 'De duración determinada') },
    { value: "De relevo", text: $t('data.contractTypes.De relevo', 'De relevo') },
    { value: "Fijo discontinuo", text: $t('data.contractTypes.Fijo discontinuo', 'Fijo discontinuo') },
    { value: "Formativo", text: $t('data.contractTypes.Formativo', 'Formativo') },
    { value: "Indefinido", text: $t('data.contractTypes.Indefinido', 'Indefinido') },
    { value: "A tiempo parcial", text: $t('data.contractTypes.A tiempo parcial', 'A tiempo parcial') },
    { value: "Otros contratos", text: $t('data.contractTypes.Otros contratos', 'Otros contratos') }
];
